$(document).ready(function () {
	var
		ua = navigator.userAgent.toLowerCase(),
		event = (ua.match(/Android/i) || ua.match(/iPad/i) || ua.match(/iPod/i) || ua.match(/iPhone/i)) ? "touchstart" : "click",
		isMobile = ua.match(/(iphone|ipod|ipad|android)/),
		window_w = $(window).width(),
		window_h = $(window).height(),
		is_home = $('body').hasClass('ishome');

	$.blockUI.defaults.message = 'Aguarde';

	/*$.cookieBar({
		message: 'Este site usa cookies. {policy_url}',
		acceptText: 'OK',
		fixed: true,
		bottom: true,
		policyButton: true,
		policyText: 'Saiba mais',
		policyURL: '#',
	});*/

	$('html').removeClass('no-js');

	if (("standalone" in window.navigator) && window.navigator.standalone) {
		$('html').addClass('ios-standalone');
	}

	if ($.browser.msie) {
		$('html').addClass('is-ie');
		$('html').addClass('ie-' + $.browser.versionNumber);
	}

	if ($.browser.msedge) {
		$('html').addClass('is-edge');
	}

	if ($.browser.iphone && $.browser.safari) {
		$('html').addClass('ios-safari');
	}

	if ($.browser.iphone && $.browser.chrome) {
		$('html').addClass('ios-chrome');
	}

	if ($.browser.android && $.browser.chrome) {
		$('html').addClass('android-chrome');
	}

	/**
	 * Trigger AOS
	 */
	/*setTimeout(function () {
		$('#loader').fadeOut(500, function () {
			$(this).remove();
		});
		AOS.init({
			'offset': -50,
			disable: 'mobile'
		});
	}, 300);*/

	/**
	 * Lazy load images
	 */
	var velcroLazy = {
        /**
         * init
		 * correr on load e sempre que for necessário, por exemplo, a seguir a uma call ajax
		 * elements: passar class dos ementos a fazer lazy load (ex: .lazy)
		 * ex: velcroLazy.init('.lazy');
         */
        init: (elements) => {
            let lazyImages = $(elements);

			if ("IntersectionObserver" in window) {
				var lazyImageObserver = new IntersectionObserver(function(entries, observer) {
					entries.forEach(function(entry) {
						if (entry.isIntersecting) {
							var lazyImage = $(entry.target),
								image = lazyImage.find('img')[0] || new Image(),
								is_bg_or_img = typeof lazyImage.data('src') !== 'undefined';

							image.onload = function () {
								if (is_bg_or_img) {//is bg
									lazyImage.css("backgroundImage", "url('" + lazyImage.data("src") + "')").removeAttr('data-src');
								}
								setTimeout(function () {
									lazyImage.addClass('loaded').removeClass("lazy").parent().removeClass('loading');
								}, 200);
							};

							image.src = is_bg_or_img ? lazyImage.data("src") : lazyImage.find('img').attr('data-src');
							lazyImageObserver.unobserve(entry.target);
						}
					});
				});

				lazyImages.each(function() {
					lazyImageObserver.observe(this);
				});
			} else {
				lazyImages.each(function() {
					var is_bg_or_img = typeof $(this).data('src') !== 'undefined';
					if (is_bg_or_img) {//is bg
						$(this).css("backgroundImage", "url('" + $(this).data("src") + "')").removeAttr('data-src');
					}else{//is img
						$(this).find('img').attr("src", $(this).find('img').data("src")).removeAttr('data-src');
					}
					$(this).addClass('loaded').removeClass("lazy").parent().removeClass('loading');
				});
			}
        }
	}

	velcroLazy.init('.lazy');

	var root = $('html,body');
	function smoothScrollingTo(target) {

		var target = $(target);
		if (target.length) {
			root.animate({
				scrollTop: target.offset().top - 100
			}, 400, "swing");
		}
	}

	$('a[href*=\\#]:not([href=\\#],[data-toggle],.open-popup)').on('click', function (event) {
		smoothScrollingTo(this.hash);
		if ($('.menu-mobile').hasClass('show')) {
			toogleMenu();
		}
	});

	smoothScrollingTo(location.hash);

	if (!Modernizr.objectfit) {
		$('body .objectfit').each(function () {
			var $container = $(this),
				imgUrl = $container.find('img').prop('src');
			if (imgUrl) {
				$container
					.css('backgroundImage', 'url(' + imgUrl + ')')
					.addClass('compat-object-fit');
			}
		});
	}

	/*===========================================================================
  	INSTAFEED.JS INSTAGRAM
  ===========================================================================*/
  if ($('#instagram-container').length > 0) {

	fetch("https://www.velcro-hosting.com/velcroinsta/funnyhowagency")
		.then((response) => response.json())
		.then((data) => {
		  
		  if(data){
			var images = data.data;
			var html = '';

			$.each(images, function (i, item) {
				if(i < 6){
					if (item.media_type == 'VIDEO') {
						html += '<div class="image"><a href="' + item.permalink + '" target="_blank"><div class="media imagem1x1 load-img-fade lazy" data-src="' + item.thumbnail_url + '"></div><div class="caption">' + truncate(item.caption, 35) +
						'</div></a></div>';
					} else {
						html += '<div class="image"><a href="' + item.permalink + '" target="_blank"><div class="media imagem1x1 load-img-fade lazy" data-src="' + item.media_url + '"></div><div class="caption">' + truncate(item.caption, 35) +
						'</div></a></div>';
					}
				}
			
			});

			$('#instagram-container').prepend(html);
			velcroLazy.init('.lazy');
		  }
		})
		.catch((error) => {
		  console.error("Error:", error);
		})
		.finally(() => {
		  this.isLoadingMessages = false;
		});
  }

});

/**
 * Block scroll
 * @param block
 */
function blockScroll(block) {
	if (block == 1) {
		$('html').addClass('block-scroll');
	} else if (block == 0) {
		$('html').removeClass('block-scroll');
	}
}

/**
 * Verificar se é um email válido
 */
function IsEmail(email) {
	var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return re.test(email) ? true : false;
}

/**
 * Verifica se a checkbox de política de privacidade está ou não seleccionada
 */
function checkPolicy(form) {
	var checked = form.find('input[name="checkpolicy[]"]:checked').length;
	if (checked === 1) {
		return true;
	}

	return false;
}

  const truncate = (str, max = 10) => {
	const array = str.trim().split(' ');
	const ellipsis = array.length > max ? '...' : '';
  
	return array.slice(0, max).join(' ') + ellipsis;
  };